import { useEffect, useState } from 'react';
import WealthPackages from './WealthPackages';
import { fetchData, textWithIcon, styles, onCellClicked } from './Helpers';
import { checkDoubleImg, crossImg, commentImg, fileKeyImg, resolveImage } from "../../images/ImageResolver";

function transformData(data){
  const rowKeys = ["display","polarity","isOnlyNonDifferentiated","isOnlyDirectCashFlow","ratio","currencyDependent","isShare","isPerShare","isPercentage","isAverage","isWholeNumber","description","endpoints","industrial","insurance","bank","property","investment","financial"]
  var tData = data.map(row => ({
    name: row.financialConceptDescription+','+row.statement_display+','+row.financialConceptCode,
    public: row.public,
    private: row.private,
    advanced: row.advanced,
    rowData: rowKeys.map(key => (row[key] ? row[key].replace(/,/g, "") : "")).join(",")
  }))
  return tData
}

function FinancialStmt() {
  const [wealth, setWealth] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.name.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Financial_Statement").then((res) => {
      setFullData(transformData(res));
      setLoading(false);
    });
  }, []);

  useEffect(() => {
      const grid = document.getElementById('grid');
      if(!wealth){
        grid.addEventListener("click", onCellClicked);
      }
    }, [wealth]);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'ITEM', field: 'name', width: 4, scalable: true, binding: cellWithMultipleLines },
      { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), binding: textWithIcon, styles: styles },
      { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: textWithIcon },
      { name: 'ADVANCED', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "advanced"), binding: textWithIcon, styles: styles },
      { name: 'PROFESSIONAL', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "professional"), binding: textWithIcon },
      { name: 'dataRow' , field: 'rowData', visible: false}
    ]

    var onRowExpansionBinding = function(e) {
      var rowData = e.originalRowData;
      // console.log(rowData);
      var data = rowData ? rowData["rowData"].split(',') : [];
      var rowIndex = e["rowIndex"];
      var section = e["section"];
      var items = ["Industrial", "Insurance", "Bank", "Property", "Investment", "Financial"];
      var indiItems = [
        {"display": data[0]||"" },
        {"polarity": data[1]||"" },
        {"Is only Non Differentiated": data[2]||"" },
        {"Is only direct cash flow": data[3]||"" },
        {"Ratio": data[4]||"" },
        {"Currency Dependent": data[5]||"" },
        {"Is Share": data[6]||"" },
        {"Is per Share": data[7]||"" },
        {"Is Percentage": data[8]||"" },
        {"Is Average": data[9]||"" },
        {"Is Whole Number": data[10]||"" }
      ]
      if (e.rowExpansion && rowData) {
        // render
        var cell = section.stretchCell(0, rowIndex, true);
        cell.setStyle("backgroundColor", "#FFFFFF");
        section.setRowHeight(rowIndex, 700); // Customized height

        var expContent = cell.getContent();
        if (!expContent || !expContent._myExpansion) {
          expContent = document.createElement("div");
          expContent._myExpansion = true;

          var firstLine = expContent._firstLine = document.createElement("ef-layout");
          firstLine.style.display = "flex";
          var desc = expContent._desc = document.createElement("ef-layout");
          desc.style.display = "flex";
          desc.style.marginTop = "20px";
          desc.style.paddingLeft = "5px";
          var secondLine = expContent._secondLine = document.createElement("ef-layout");
          secondLine.style.display = "flex";
          secondLine.style.paddingBottom = "10px";
          var thridLine = expContent._thirdLine = document.createElement("ef-layout");
          thridLine.style.paddingLeft = "5px";
          thridLine.style.marginTop = "10px";

          items.forEach((item, i) => {
            var cLayout = document.createElement("ef-layout");
            cLayout.maxWidth = "20%";
            cLayout.style.fontWeight = "600";
            cLayout.style.backgroundColor = "#fafaff";
            cLayout.style.color = "#0d0d0d";
            cLayout.style.border = "1px solid #e6e6e6";
            cLayout.style.padding = "15px 20px";
            cLayout.style.margin = "10px 5px";
            cLayout.style.borderRadius = "6px";
            cLayout.style.fontSize = "14px";
            // cLayout.style.height = "49px";
            var iconImg = document.createElement("img");
            if (data[13 + i] === "x") {
              iconImg.src = checkDoubleImg;
            }else {
              iconImg.src = crossImg;
            }
            iconImg.style.marginRight = "10px";
            cLayout.appendChild(iconImg);
            var pillText = document.createElement("span");
            pillText.textContent = item;
            cLayout.appendChild(pillText);
            var iconImg2 = document.createElement("img");
            iconImg2.src = resolveImage(item);
            iconImg2.style.float = "right";
            iconImg2.style.marginLeft = "10px";
            cLayout.appendChild(iconImg2);
            firstLine.appendChild(cLayout);           
          });

          var descImage = document.createElement("img");
          descImage.src = commentImg;
          descImage.style.marginRight = "10px";
          descImage.style.width = "24px";
          descImage.style.height = "24px";
          desc.appendChild(descImage);
          var descText = document.createElement("h2");
          descText.textContent = "Description";
          descText.style.fontWeight = "600";
          descText.style.fontSize = "16px";
          descText.style.color = "#001eff";
          descText.style.margin = "0px";
          desc.appendChild(descText);

          var descLayout = document.createElement("ef-layout");
          descLayout.style.width = "60%";
          descLayout.style.fontWeight = "400";
          descLayout.style.backgroundColor = "transparent";
          descLayout.style.color = "#666666";
          descLayout.style.border = "none";
          descLayout.style.padding = "10px 30px 10px 0px";
          descLayout.style.margin = "10px 5px";
          descLayout.style.fontSize = "16px";
          descLayout.style.whiteSpace = "pre-line";
          descLayout.innerHTML = data[11];
          secondLine.appendChild(descLayout);

          var indiLayout = document.createElement("ef-layout");
          indiLayout.style.fontWeight = "400";
          indiLayout.style.backgroundColor = "#f8f8f8";
          indiLayout.style.color = "#1a1a1a";
          indiLayout.style.border = "none";
          indiLayout.style.padding = "10px 20px";
          indiLayout.style.margin = "10px 5px";
          indiLayout.style.fontSize = "16px";

          indiItems.forEach((item, i) => {
            var indiDiv = document.createElement("div");
            indiDiv.style.marginBottom = "10px";
            indiDiv.style.textTransform = "capitalize";
            var indiText = document.createElement("span");
            indiText.style.display = "inline-block";
            indiText.style.marginTop = "5px";
            indiText.innerHTML = Object.keys(item);
            indiDiv.appendChild(indiText);
            var indiPill = document.createElement("ef-pill");
            indiPill.style.fontWeight = "400";
            const val = String(Object.values(item)).toLowerCase();
            if (val === "positive" || val === "yes") {
              indiPill.style.backgroundColor = "#87dca7";
              indiPill.style.color = "#333333";
              indiPill.textContent = Object.values(item);
            } else if (val === "negative" || val === "no") {
              indiPill.style.backgroundColor = "#faa8b1";
              indiPill.style.color = "#333333";
              indiPill.textContent = Object.values(item);
            } else if (val === "1") {
              indiPill.style.backgroundColor = "#87dca7";
              indiPill.style.color = "#333333";
              indiPill.textContent = "Yes";
            } else if (val === "0") {
              indiPill.style.backgroundColor = "#faa8b1";
              indiPill.style.color = "#333333";
              indiPill.textContent = "No";
            } else {
              indiPill.style.backgroundColor = "#e8e8e8";
              indiPill.style.color = "#333333";
              indiPill.textContent = Object.values(item);
            }
            indiPill.style.border = "none";
            indiPill.style.padding = "14px 20px";
            indiPill.style.margin = "5px 15px";
            indiPill.style.borderRadius = "20px";
            indiPill.style.float = "right";
            indiPill.style.fontSize = "14px";
            indiPill.style.fontWeight = "400";
            indiPill.style.minWidth = "90px";
            indiDiv.appendChild(indiPill);
            indiLayout.appendChild(indiDiv);
          });
        
          secondLine.appendChild(indiLayout);

          var endpointLabel = document.createElement("label");
          var endpointInput = document.createElement("ef-text-field");
          endpointLabel.textContent = "Endpoint:";
          endpointLabel.style.fontWeight = "600";
          endpointLabel.style.marginRight = "0px";
          endpointLabel.style.color = "#334d6e";
          endpointLabel.style.fontSize = "16px";
          endpointLabel.style.height = "42px";
          endpointLabel.style.padding = "10px 20px 14px 20px";
          endpointLabel.style.backgroundColor = "#e8e8e8";
          endpointLabel.style.border = "1px solid #e8e8e8";
          endpointInput.value = data[12];
          endpointInput.style.width = "60%";
          endpointInput.style.padding = "10px 20px";
          endpointInput.readOnly = true;
          endpointInput.style.color = "#334d6e";
          endpointInput.style.fontSize = "14px";
          endpointInput.style.border = "1px solid #e8e8e8";
          endpointInput.style.height = "40px";
          thridLine.appendChild(endpointLabel);
          thridLine.appendChild(endpointInput);

          expContent.appendChild(firstLine);
          expContent.appendChild(desc);
          expContent.appendChild(secondLine);
          expContent.appendChild(thridLine);
        }

        rowData = e.originalRowData;
        cell.setContent(expContent);
      } else {
        // dispose
        cell = section.stretchCell(0, rowIndex, false);
        cell.setStyle("backgroundColor", "");
        section.setRowHeight(rowIndex, section.getDefaultRowHeight()); // Default height
      }
    }

    function cellWithMultipleLines(e) {
      var cell = e.cell;
      var content = cell.getContent();
      if (!content) {
        let rowData = e.data.split(',');
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        var firstLine = document.createElement("button");
        var firstLineIcon = document.createElement("ef-icon");
        var firstLineText = document.createElement("span");
        firstLineIcon.icon = "right";
        firstLineIcon.style.marginRight = "10px";
        firstLine.style.fontWeight = "600";
        firstLine.style.color = "#0f1e8a";
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.style.fontSize = "14px";
        firstLine.style.cursor = "pointer";
        firstLine._firstLineIcon = firstLineIcon;
        firstLine.appendChild(firstLineIcon);
        firstLineText.textContent = rowData[0];
        firstLine.appendChild(firstLineText);
        content._firstLine = firstLine;
        content.appendChild(firstLine);
        content.appendChild(document.createElement("br"));

        var secondLine = document.createElement("ef-pill");
        secondLine.style.fontWeight = "400";
        secondLine.style.backgroundColor = "#ffefb3";
        secondLine.style.color = "#665000";
        secondLine.style.border = "none";
        secondLine.style.padding = "15px 20px";
        secondLine.style.margin = "10px 25px";
        secondLine.style.borderRadius = "4px";
        secondLine.style.fontSize = "14px";
        content._secondLine = secondLine;
        content.appendChild(secondLine);
        content._secondLine.textContent = rowData[1];

        var secondLine2 = document.createElement("ef-pill");
        var secondLine22 = document.createElement("span");
        var secondLine2Icon = document.createElement("img");
        secondLine2Icon.src = fileKeyImg;
        secondLine2Icon.style.marginRight = "5px";
        secondLine2Icon.style.marginTop = "5px";
        secondLine22._secondLine2Icon = secondLine2Icon;
        secondLine22.appendChild(secondLine2Icon);
        secondLine2.style.fontWeight = "400";
        secondLine2.style.backgroundColor = "transparent";
        secondLine2.style.color = "#999999";
        secondLine2.style.border = "none";
        secondLine22.textContent = rowData[2];
        secondLine22.style.fontSize = "14px";
        secondLine22.style.display = "inline-flex";
        secondLine22.style.verticalAlign = "super";
        secondLine2.appendChild(secondLine2Icon);
        secondLine2.appendChild(secondLine22);
        content._secondLine2 = secondLine2;
        content.appendChild(secondLine2);

        content.addEventListener("click", function() {
          if (firstLineIcon.icon === "right") {
            firstLineIcon.icon = "down";
          } else {
            firstLineIcon.icon = "right";
          }
        });
      }
      cell.setContent(content);
    }

    function headerWithLink(text, i, e) {
      var cell = e.cell;
      var content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        var span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        var link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        var image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        var span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    if(!wealth){
      grid.config = {
        rowHeight: 90,
        headerRowHeight: 60,
        virtualScroll: true,
        rowBuffer: 15,
        suppressRowTransform: true,
        enableTextWrap: false,
        columns: columns,
        dataModel: {
          data: searchData.length > 0 ? searchData : fullData
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index
              sortOrder: "a"
          }
        },
        rowFiltering: {
          disabledUI: true
      },
        rowExpansionBinding: onRowExpansionBinding
      };
    }
  }, [searchData, fullData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <div id='loadingMask_div'>
          <h4>LSEG COMPANY SNAPSHOT</h4>
          <p>This is a complete list of all the Financial Statements data items available through the Company Snapshot packages</p>
          <ef-layout flex style={{ marginTop: '20px' }}>
            <ef-layout>
              <input
                className='search-field'
                type="text"
                placeholder="Type to search..."
                onChange={(e) => searchEvent(e.target.value)}
              />
            </ef-layout>
          </ef-layout>
          <efx-grid id="grid" className="entity-grid"></efx-grid>
        </div>
      )}
    </div>
  );
}

export default FinancialStmt;
